import { memo, useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import PopverButton from '@/components/PopverButton/PopverButton'
import { Modal } from 'antd'
import './BaseModal.less'
const BaseModal = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(props.visible)
  useEffect(() => {
    setIsModalOpen(props.visible)
  }, [props.visible])
  const onCancel = () => props.onCancel?.()
  const onOk = () => props.onOk?.()

  return (
    <Modal
      wrapClassName={`${props.className || ''} base-modal-container`}
      open={isModalOpen}
      onOk={onOk}
      onCancel={onCancel}
      title=''
      footer={null}
      centered
      width={1000}
      {...props.modalProps}
    >
      {props.title && <h3>{props.title}</h3>}
      <div className='content'>{props.children}</div>
      {(props.leftBtn || props.rightBtn || props?.customBtns) && (
        <div className={`btn-wrapper ${props.leftBtn && props.rightBtn ? 'btn-wrapper-2' : 'btn-wrapper-1'}`}>
          {props.leftBtn && (
            <PopverButton
              type={props.leftBtn.type || 'default'}
              onClick={props.leftBtn.onOk}
              text={props.leftBtn.text || '上一步'}
              content={props.leftBtn.content}
              isGradient={props.leftBtn.isGradient || false}
              disabled={props.leftBtn.disabled}
              className={props.leftBtn.className || ''}
              style={props.leftBtn.style || {}}
            />
          )}
          {props.rightBtn && (
            <PopverButton
              type={props.rightBtn.type || 'primary'}
              onClick={props.rightBtn.onOk}
              text={props.rightBtn.text || '下一步'}
              content={props.rightBtn.content}
              isGradient={props.rightBtn.isGradient || false}
              disabled={props.rightBtn.disabled}
              className={props.rightBtn.className || ''}
              style={props.rightBtn.style || {}}
            />
          )}
          {props?.customBtns}
        </div>
      )}
    </Modal>
  )
}

export default memo(withRouter(BaseModal))
